import Immutable from 'immutable';
import { handleActions } from 'redux-actions';
import { TYPES as FEATURE_FLAG_ACTION_TYPES } from 'actions/featureFlagActions';

const classNameAssignment = {
  MobileSearchNoBackground: 'no-background',
  BookPassengerDetailsOnOneLine: 'details-on-one-line',
  BookPaypalWithoutTab: 'paypal-without-tab',
  InterstitialModalNewLogos: 'interstitial-new-logos-desktop',
};

const initialState = Immutable.fromJS({
  classNameList: [],
});

export default handleActions({
  [FEATURE_FLAG_ACTION_TYPES.SET_FEATURE_FLAG]: (state, { featureFlag }) => {
    let newState = state;

    if (classNameAssignment[featureFlag]) {
      newState = newState.set('classNameList', newState.get('classNameList').push(classNameAssignment[featureFlag]));
    }

    return newState.set(featureFlag, true);
  },
}, initialState);



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/featureFlagsReducer.js
 **/